var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NoteList',{attrs:{"delete-permission":'delete_auction',"change-permission":'change_auction',"object-uuid":_vm.reservation.uuid,"plural-object-name":"inventories/reservations","object-name":"reservation","is-loading-text":false}})}
var staticRenderFns = []

export { render, staticRenderFns }